export const MAIN_APP = process.env.PUBLIC_URL;
export const LOGIN_PAGE = MAIN_APP + "/login";
export const REMIND_PASS_PAGE = MAIN_APP + "/remindPass";
export const REGISTRATION_PAGE = MAIN_APP + "/registration";
export const REGISTRATION_SUCCESS_PAGE = MAIN_APP + "/registrationSuccess";
export const FINALIZE_PAGE = MAIN_APP + "/finalize";
export const NEWS_PAGE = MAIN_APP + "/news";
export const LIMITED_TICKET_COLOR = MAIN_APP + "/ticketsColor";
export const LIMITED_TICKET_GROUP = MAIN_APP + "/ticketsGroup";
export const LIMITED_TICKET_SHAPE = MAIN_APP + "/ticketsShape";
export const EVENT_SALE = MAIN_APP + "/events";
export const TOUR_SALE = MAIN_APP + "/tours";
export const CALENDAR_SALE = MAIN_APP + "/calendarSale";
export const CUSTOM_OFFER = MAIN_APP + "/customOffer";
export const OFFER_SHOWCASE = MAIN_APP + "/offerShowcase";
export const THREE_STEP = MAIN_APP + "/stepsSale";
export const PASSES_SALE = MAIN_APP + "/passes";
export const EXERCISE_SCHEDULE = MAIN_APP + "/schedule";
export const GIFT_CARD_ACTIVE = MAIN_APP + "/giftCards";
export const ECARD_RECHARGE = MAIN_APP + "/cardRecharge";
export const BIRTHDAY_RESERVATION = MAIN_APP + "/birthdayReservation";
export const MODAL_TEST = MAIN_APP + "/modalWindow";
export const TOUR_DETAILS = MAIN_APP + "/tourDetails";
export const ACCOUNT_ACTIVATION = MAIN_APP + "/accountActivation";
export const HOURLY_SCHEDULE = MAIN_APP + "/hourlySchedule";
export const NEWSLETTER_FORM_WIDGET = MAIN_APP + "/newsletterFormWidget";
export const NEWSLETTER_CONFIRMATION = MAIN_APP + "/confirmNewsletter";
export const NEWSLETTER_FORM_RESIGN = MAIN_APP + "/resignNewsletter"
export const CHANGE_PASSWORD_CONFIRMATION = MAIN_APP + "/confirmChangePassword";
export const PURCHASE = MAIN_APP + "/purchaseSuccess";
export const PURCHASE_FAILED = MAIN_APP + "/purchaseFailed";      
export const WELCOME_MOBILE = MAIN_APP + "/welcomeMobile";
export const GDANSK_SALE = MAIN_APP + "/gdanskSale";
export const REGISTER_B2B = MAIN_APP + "/register-b2b";
export const REGISTER_PARTICIPANTS_PAGE = MAIN_APP + "/registerParticipants";
export const CARD_PURCHASE_LOOKUP = MAIN_APP + "/card-purchase-lookup";
